// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".code-preview[data-v-dcf3e872]{background-color:#7a95a4;border-radius:5px;color:#000;font-family:Fira Code;font-size:1.2rem;height:100%;line-height:2rem;overflow-x:hidden;overflow-y:auto;padding:10px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
